import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { BsCheckCircle } from "react-icons/bs";
import { AiOutlineFilePdf } from "react-icons/ai";
import { formatCurrencyUtil, formatNumberUtil, getBhkTypesString, getImageUrl, getMinMaxPrice } from "../../../../Utils/localStorageUtils";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";

const ProjectDetails = ({ project }) => {
  const {goToNewTab} = useCustomNavigate()

  if (!project || Object.keys(project).length === 0) return null;
  console.log(project, "projeprojectctproject")


  const {
    basicDetails = {},
    projectDetails = {},
    media = {},
    floorPricingDetails = []
  } = project;

  const { projectName, projectBuilder, location, price, bhkType } = basicDetails;
  const { status, launchDate } = projectDetails;
  const { brochure,payment_plan } = media;

 const {minPrice="", maxPrice="" }  =  getMinMaxPrice(floorPricingDetails)


  // Price display logic
  let priceText = "";
  if (minPrice && maxPrice) {
    priceText = `${formatCurrencyUtil(minPrice)} - ${formatCurrencyUtil(maxPrice)}`;
  } else if (minPrice) {
    priceText = `${formatCurrencyUtil(minPrice)}`;
  } else if (maxPrice) {
    priceText = `${formatCurrencyUtil(maxPrice)}`;
  }



  return (
    <div className="bg-white p-6 ">
      {/* Header Section */}
      <div className="flex justify-between items-start">
        <div>
          <div className="flex items-center space-x-2 text-yellow-500 text-sm">
            <span className="flex items-center bg-yellow-100 px-2 py-1 rounded">
              ⭐ 4.3 (6 Ratings)
            </span>
          </div>
          {projectName && <h2 className="text-2xl font-semibold text-gray-800">{projectName}</h2>}

          {projectBuilder && <p className="text-gray-600">By {projectBuilder}</p>}
          {location && (
            <p className="text-gray-600 flex items-center mt-1">
              <IoLocationOutline className="mr-1" /> {location?.formatted_address || "Jaipur"}
            </p>
          )}
          {status && launchDate && (
            <p className="text-green-600 flex items-center mt-2">
              <BsCheckCircle className="mr-1" /> {status} in {new Date(launchDate).toLocaleString('default', { month: 'short', year: 'numeric' })}
            </p>
          )}
        </div>
        <div className="text-right">
          <div className="flex items-center space-x-1 text-yellow-500">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStarHalfAlt />
            <span className="text-gray-500 text-sm ml-1">6 reviews</span>
          </div>
          <button className="border border-red-500 text-red-500 px-3 py-1 rounded-full mt-2 hover:bg-red-100">
            Write a review
          </button>
        </div>
      </div>

      {/* Price Section */}
      <div className="mt-4">
      {priceText && <p className="text-xl font-semibold text-gray-800"> {priceText}</p>}
        <a href="#" className="text-blue-600 text-sm underline">
          Check Market Value
        </a>
      {floorPricingDetails.length > 0 && <p className="text-gray-700 mt-1"> {getBhkTypesString(floorPricingDetails) } Flat</p>}
      </div>

      {/* Buttons Section */}
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="bg-red-600 text-white px-4 py-2 rounded-md font-semibold hover:bg-red-700">
          Contact Owner
        </button>
      { brochure && <button onClick={()=>{goToNewTab(`${getImageUrl(brochure)}`)}} className="flex items-center border border-red-500 px-4 py-2 rounded-md text-red-500 hover:bg-red-100">
          <AiOutlineFilePdf className="mr-2" /> Download Brochure
        </button>}
     { payment_plan &&  <button className="flex items-center border border-red-500 px-4 py-2 rounded-md text-red-500 hover:bg-red-100">
          <AiOutlineFilePdf className="mr-2" /> Download Payment Plan
        </button>}
      </div>
    </div>
  );
};

export default ProjectDetails;
